/*
 * «Desliza hacia arriba para contestar, hacia abajo para rechazar», como la app Teléfono de Google.
 * Arrastre con pointer events (dedo o ratón); pasado el umbral contesta o rechaza, si no vuelve a su sitio.
 * Para teclado y lectores de pantalla hay dos botones (Contestar / Rechazar) visualmente ocultos.
 */
import React, { useRef, useState } from 'react';
import { ChevronUp, Phone, PhoneOff, Video } from 'lucide-react';

const UMBRAL = 90;

export default function Deslizador({ video, alContestar, alRechazar, ocupado }) {
  const [dy, setDy] = useState(0);
  const [arrastrando, setArrastrando] = useState(false);
  const inicio = useRef(null);

  const bajar = (e) => {
    if (ocupado) return;
    inicio.current = e.clientY;
    setArrastrando(true);
    e.currentTarget.setPointerCapture?.(e.pointerId);
  };
  const mover = (e) => {
    if (inicio.current == null) return;
    setDy(Math.max(-160, Math.min(160, e.clientY - inicio.current)));
  };
  const soltar = () => {
    if (inicio.current == null) return;
    inicio.current = null;
    setArrastrando(false);
    if (dy <= -UMBRAL) alContestar();
    else if (dy >= UMBRAL) alRechazar();
    setDy(0);
  };

  const hacia = dy < -20 ? 'contestar' : dy > 20 ? 'rechazar' : null;
  return (
    <div className="dz" data-testid="meet-deslizador">
      <span className={`dz-pista ${hacia === 'rechazar' ? 'is-oculta' : ''}`} aria-hidden="true">
        <ChevronUp size={22} /><ChevronUp size={22} />
      </span>
      <span className="dz-texto" aria-hidden="true">
        {hacia === 'rechazar' ? 'Suelta para rechazar' : hacia === 'contestar' ? 'Suelta para contestar' : 'Desliza hacia arriba para contestar'}
      </span>
      <div className="dz-carril">
        <div
          className={`dz-boton ${hacia ? `is-${hacia}` : ''} ${arrastrando ? '' : 'is-suelto'}`}
          style={{ transform: `translateY(${dy}px)` }}
          onPointerDown={bajar}
          onPointerMove={mover}
          onPointerUp={soltar}
          onPointerCancel={soltar}
          role="presentation"
        >
          {hacia === 'rechazar' ? <PhoneOff size={30} /> : video ? <Video size={30} /> : <Phone size={30} />}
        </div>
      </div>
      <span className="dz-abajo" aria-hidden="true">Desliza hacia abajo para rechazar</span>
      <button type="button" className="dz-oculto" onClick={alContestar} data-testid="meet-llamada-aceptar">Contestar</button>
      <button type="button" className="dz-oculto" onClick={alRechazar} data-testid="meet-llamada-rechazar">Rechazar</button>
    </div>
  );
}
